import $ from 'jquery';

$.fn.findWithRoot = function(selector) {
  return this.filter(selector).add(this.find(selector));
};